import '@/installFineMq'

import Vue from 'vue'

import SanitasAccordion from '@/modules/collapsible/SanitasAccordion'
import SanitasCollapsible from '@/modules/collapsible/SanitasCollapsible'
import { mount } from '@/mounter'

import SanitasTabItem from './SanitasTabItem'
import SanitasTabs from './SanitasTabs'

// load used components inside tabs as global components
Vue.component('SanitasAccordion', SanitasAccordion)
Vue.component('SanitasCollapsible', SanitasCollapsible)

// mount the tabs later to be sure that all other vue components have been mounted before and will be
// added to the tabs slots already mounted.
mount('tabs', { SanitasTabs, SanitasTabItem })
